import { mutate } from 'swr';

import { getCompanyEquipmentList } from '.';

export const prefetchEquipmentData = () => {
  mutate('equipList', getCompanyEquipmentList());
};
